<div class="file-content">
  @if (url) {
    <div class="file-display">
      <div class="file-display">
        @switch (displayOption) {
          @case (DisplayOptions.image) {
            <div class="image-viewer">
              <img [src]="url" />
            </div>
          }
          @case (DisplayOptions.video) {
            <div class="video-viewer">
              <video controls>
                <source [src]="safeResourceUrl" />
              </video>
            </div>
          }
          @case (DisplayOptions.audio) {
            <div class="audio-viewer">
              <audio controls>
                <source [src]="safeResourceUrl" />
              </audio>
            </div>
          }
          @case (DisplayOptions.pdf) {
            <div class="pdf-viewer">
              <object [data]="safeResourceUrl" type="application/pdf"></object>
            </div>
          }
          @case (DisplayOptions.link) {
            <div class="link-viewer">
              @if (url) {
                <a href="{{ url }}" mat-stroked-button target="_blank">
                  <mat-icon>download</mat-icon>
                  <span>{{ fileName }}</span>
                </a>
              }
            </div>
          }
        }
      </div>
    </div>
  }
</div>
